import React, { type FC, type PropsWithChildren } from 'react'
import { Box, Divider, type SxProps, type Theme } from '@mui/material'

import { Autocompletes } from './Autocompletes'
import { Buttons } from './Buttons'
import { Chips } from './Chips'
import { Dropdowns } from './Dropdowns'
import { Inputs } from './Inputs'
import { Notifications } from './Notifications'
import { Shadows } from './Shadows'
import { Statuses } from './Statuses'
import { Tables } from './Tables'
import { Typography } from './Typography'

const dividerStyle: SxProps<Theme> = { my: 10 }
const subpageStyle: SxProps<Theme> = { py: 4 }

const Subpage: FC<PropsWithChildren> = ({ children }) => <Box sx={subpageStyle}>{children}</Box>

export const StorybookFoundations: FC = () => (
    <Subpage>
        <Typography />
        <Divider sx={dividerStyle} />
        <Shadows />
    </Subpage>
)

export const StorybookInputs: FC = () => (
    <Subpage>
        <Inputs />
        <Divider sx={dividerStyle} />
        <Autocompletes />
        <Divider sx={dividerStyle} />
        <Dropdowns />
    </Subpage>
)

export const StorybookButtons: FC = () => (
    <Subpage>
        <Buttons />
    </Subpage>
)

export const StorybookChipsAndStatuses: FC = () => (
    <Subpage>
        <Chips />
        <Divider sx={dividerStyle} />
        <Statuses />
    </Subpage>
)

export const StorybookTables: FC = () => (
    <Subpage>
        <Tables />
    </Subpage>
)

export const StorybookNotifications: FC = () => (
    <Subpage>
        <Notifications />
    </Subpage>
)
